import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Account (/account)
 */
export const accountTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Account_Form_Title"),
    description: t("Tour_Account_Form_Description"),
    target: () => queryTourTarget("account-profile-form"),
    placement: "bottom",
  },
  {
    title: t("Tour_Account_Avatar_Title"),
    description: t("Tour_Account_Avatar_Description"),
    target: () => queryTourTarget("account-avatar"),
    placement: "bottom",
  },
  {
    title: t("Tour_Account_Save_Title"),
    description: t("Tour_Account_Save_Description"),
    target: () => queryTourTarget("account-save"),
    placement: "left",
  },
];
